import React from 'react';
import { RewardsList } from 'components';
import { H2 } from 'components/design-components';

const Rewards = props => (props.rewards.length ? <RewardsList {...props} /> : <H2>No rewards</H2>);

Rewards.propTypes = RewardsList.propTypes;
Rewards.defaultProps = RewardsList.defaultProps;

export default Rewards;